import { i18n } from "@src/i18n/i18n";
import { Recurrences } from "@src/services/Calendar/enums";
export const recurrenceOptions = [
    { label: i18n.t("not-recurring"), value: Recurrences.none },
    { label: i18n.t("daily"), value: Recurrences.daily },
    { label: i18n.t("weekly"), value: Recurrences.weekly },
    { label: i18n.t("monthly"), value: Recurrences.monthly },
];
